import React from 'react';

interface StatusMessageProps {
  children: React.ReactNode;
}

export const ErrorMessage: React.FC<StatusMessageProps> = ({ children }) => (
  <div className="p-3 mb-4 bg-red-900/40 border border-red-500 text-red-400 text-[9px] lg:text-xs pixel-border text-center font-bold uppercase tracking-wider">
    {children}
  </div>
);

export const SuccessMessage: React.FC<StatusMessageProps> = ({ children }) => (
  <div className="p-3 mb-4 bg-green-900/40 border border-green-500 text-green-400 text-[9px] lg:text-xs pixel-border text-center font-bold uppercase tracking-wider">
    {children}
  </div>
);
